import { Theme } from '@mui/joy';
import { iconButtonClasses, styled } from '@mui/material';
import DatePicker from 'react-datepicker';

interface IProps {
  error?: boolean;
}

const propsToSkip: PropertyKey[] = ['error'];
const shouldForwardProp = (propName: PropertyKey) => !propsToSkip.includes(propName);

export const DatePickerStyled = styled(DatePicker, { shouldForwardProp })<IProps>(
  ({ theme, error }) => ({
    border: `1px solid ${
      error ? theme.palette.danger.solidBg : theme.palette.ag.input.borderColor
    }`,

    '&:focus, &:hover': {
      border: `1px solid ${
        error ? theme.palette.danger.solidBg : theme.palette.ag.input.borderColor
      }`,
    },
  })
);

export const clearButtonStyle = (theme: Theme) => ({
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.body,
  borderRadius: '3px',
  padding: '4px',
  marginRight: '8px',
  '&:hover': {
    backgroundColor: theme.palette.neutral.plainActiveBg,
  },
  svg: {
    height: 16,
    width: 16,
  },
});

export const inputAdornmentStyle = (theme: Theme) => ({
  [`& .${iconButtonClasses.edgeEnd}`]: {
    backgroundColor: 'transparent',
    color: theme.palette.text.primary,
    borderRadius: '3px',
    padding: '4px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    svg: {
      color: 'inherit',
    },
  },
});

export const popperStyle = (theme: Theme) => ({
  '.MuiDateCalendar-root': {
    fontFamily: theme.fontFamily,

    button: {
      borderRadius: '3px',
    },

    '& .MuiDayCalendar-weekDayLabel': {
      color: theme.palette.text.primary,
    },
    '& .MuiPickersDay-root': {
      color: theme.palette.text.primary,
    },
    '& .MuiPickersDay-root.Mui-disabled': {
      color: theme.palette.text.tertiary,
    },
    '& .MuiPickersDay-root.Mui-selected': {
      backgroundColor: theme.palette.primary.solidBg,
      color: theme.palette.common.white,
    },
    '& .MuiPickersArrowSwitcher-root, & .MuiPickersCalendarHeader-label': {
      color: theme.palette.text.primary,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.text.primary,
    },
  },
  '& .MuiPaper-root': {
    borderRadius: '3px',
    backgroundColor: theme.palette.background.body,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.ag.input.borderColor}`,
    boxShadow: '0px 2px 4px 0px rgba(21, 21, 21, 0.08), 0px 1px 2px 0px rgba(21, 21, 21, 0.08)',
  },
});
